import { apiRequest } from './client';
import type { MemberView, OrganizationView } from './types';

export const organizations = {
  list: () => apiRequest<OrganizationView[]>('/api/organizations'),
  get: (id: string) => apiRequest<OrganizationView>(`/api/organizations/${id}`),
  members: (id: string) => apiRequest<MemberView[]>(`/api/organizations/${id}/members`),
  updateDefaultBranches: (id: string, branches: string[]) =>
    apiRequest<OrganizationView>(`/api/organizations/${id}/default-branches`, {
      method: 'PATCH',
      body: { branches },
    }),
};
